import { sendGet, sendPut } from "./axios";

export const getListTherapistManagement = (params) => sendGet("/therapists-management", params);

export const updateTherapistManagement = (params) =>
  sendPut(`/therapists-management/update-multiple`, params);
